// Polyfills must load before any other module (Hermes is missing some web
// globals that dependencies reference at import time). Keep this import first.
import "./polyfills"
import "@expo/metro-runtime"

// Configure the design-system Unistyles runtime (side-effect import).
// Must run BEFORE App so primitives see a configured StyleSheet on first render.
import "./src/design-system/unistyles"

import { registerRootComponent } from "expo"
import { Platform } from "react-native"

import {
    applyAppearanceMove,
    parentAppearanceAt,
} from "./src/ports/primary/ui/hooks/parentAppearance"
import App from "./App"

// L'app n'est plus épinglée au clair par son Info.plist (`userInterfaceStyle: "automatic"`) —
// sans quoi l'espace parent ne pourrait pas passer sur la nuit. Mais tout le reste — élève,
// tuteur, écrans legacy — n'a pas de version sombre, clavier et alertes du système compris : on
// repose donc le clair d'entrée de jeu, et seul l'espace parent rendra la main au système.
applyAppearanceMove(parentAppearanceAt("start", Platform.OS))

// Env-var-gated entry: `EXPO_PUBLIC_USE_STORYBOOK=true expo start` mounts the
// on-device Storybook instead of the regular App.
//
// Le préfixe EXPO_PUBLIC_ n'est pas cosmétique : c'est la seule famille de
// variables que babel-preset-expo inline et que Metro injecte dans le
// `process.env` du bundle. Sans lui, la lecture vaut `undefined` sur appareil
// et Storybook ne se monte jamais — vérifié sur simulateur iOS.
//
// The Storybook entry MUST be pulled in via a conditional `require` (not a
// static `import`). A static import always runs the module's side effects at
// load time — Storybook's `start()` and its eager `require.context` of every
// *.stories file would then execute inside the normal app, throwing in
// `storybook.requires` and corrupting the Unistyles registry (white screen).
// A `require` inside the branch is only evaluated when the flag is on, and
// Metro strips it from production bundles where the env var is unset.
const ROOT =
    process.env.EXPO_PUBLIC_USE_STORYBOOK === "true"
        ? require("./.rnstorybook").default
        : App

registerRootComponent(ROOT)
